var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4516 17H4.80645L3 15.1935V3H17.4516V17Z",
    stroke: "#111111",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3618 17.3646H17.8618V16.8646V3.36133V2.86133H17.3618H3.09082H2.59082V3.36133V15.1484V15.3555L2.73727 15.502L4.4534 17.2181L4.59984 17.3646H4.80695H17.3618Z",
    fill: "#111111",
    stroke: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3873 17.5C14.1602 17.5 14.7905 16.8697 14.7905 16.0968V12.0323C14.7905 11.2593 14.1602 10.629 13.3873 10.629H5.70987C4.93695 10.629 4.30664 11.2593 4.30664 12.0323V16.0968C4.30664 16.8697 4.93695 17.5 5.70987 17.5H13.3873Z",
    fill: "white",
    stroke: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37096 15.5967H6.66129V12.5322H8.37096V15.5967Z",
    fill: "#111111",
    stroke: "#111111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0485 8.82263H4.40332V3.95166H16.0485V8.82263Z",
    fill: "white",
    stroke: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.47501ea91d295d5702bb9762f06ed793.svg";
export { ForwardRef as ReactComponent };